import { useSelector } from "react-redux"
import { selectLeads } from "./leadsSlice"

export const useLeads = () => {
  const { body, updating } = useSelector(selectLeads)

  return {
    body,
    updating
  }
}